import * as T from '../../../../../../../components/Table'
import { formatPrice } from '../../../../../../../utils/formatPrice'
export function Item({ item, index }) {
    return (
        <T.Tbody>
            <T.Tr>
                <T.Td bg={index % 2 === 0 ? '#EDF2F7important' : 'white!important'} border="1px solid #ccc!important" p={1}>
                    {index + 1}
                </T.Td>
                <T.Td bg={index % 2 === 0 ? '#EDF2F7important' : 'white!important'} border="1px solid #ccc!important" p={1}>
                    {item?.nome_produto}
                </T.Td>
                <T.Td bg={index % 2 === 0 ? '#EDF2F7important' : 'white!important'} border="1px solid #ccc!important" p={1}>
                    {item?.codigo_produto}
                </T.Td>
                <T.Td bg={index % 2 === 0 ? '#EDF2F7important' : 'white!important'} border="1px solid #ccc!important" p={1}>
                    {item?.descricao_cor}
                </T.Td>
                <T.Td bg={index % 2 === 0 ? '#EDF2F7important' : 'white!important'} border="1px solid #ccc!important" p={1}>
                    {item?.nome_personalizacao}
                </T.Td>
                <T.Td bg={index % 2 === 0 ? '#EDF2F7important' : 'white!important'} border="1px solid #ccc!important" p={1}>
                    {item?.quantidade}
                </T.Td>
                <T.Td bg={index % 2 === 0 ? '#EDF2F7important' : 'white!important'} border="1px solid #ccc!important" p={1}>
                    {formatPrice(item?.original_preco_venda)}
                </T.Td>
                <T.Td bg={index % 2 === 0 ? '#EDF2F7important' : 'white!important'} border="1px solid #ccc!important" p={1}>
                    {formatPrice(item?.original_valor_total_itens)}
                </T.Td>
                <T.Td bg={index % 2 === 0 ? '#EDF2F7important' : 'white!important'} border="1px solid #ccc!important" p={1}>
                    {item?.cubagem.dimensoes.caixa}
                </T.Td>
                <T.Td bg={index % 2 === 0 ? '#EDF2F7important' : 'white!important'} border="1px solid #ccc!important" p={1}>
                    {item?.quantidade_caixa}
                </T.Td>
                <T.Td bg={index % 2 === 0 ? '#EDF2F7important' : 'white!important'} border="1px solid #ccc!important" p={1}>
                    {parseFloat(item.cubagem.unitario).toFixed(2)}
                </T.Td>
                <T.Td bg={index % 2 === 0 ? '#EDF2F7important' : 'white!important'} border="1px solid #ccc!important" p={1}>
                    {parseFloat(item?.cubagem?.total).toFixed(2)}
                </T.Td>
            </T.Tr>
        </T.Tbody>
    )
}
